import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { style: {"min-height":"45vw"} }
const _hoisted_2 = { class: "content pl-3 w-100" }
const _hoisted_3 = { class: "row mr-3 ml-3 v-theme--light" }
const _hoisted_4 = { class: "mb-4" }
const _hoisted_5 = {
  key: 0,
  class: "form-footer p-2"
}

import Api from "@/services/api/ApiServiceFabrick"
import AuthorityCacheApi from "@/services/models/AuthorityCacheApi"
import createOrUpdateSubManagementOffice from "@/types/requests/createOrUpdateSubManagementOffice"
import TextField from "@/components/Common/FormTextField.vue"
import TextArea from "@/components/Common/FormTextArea.vue"
import AddressForm from "@/components/SubManagementOfficeForm/AddressForm.vue"
import TelephoneNumberForm from "@/components/SubManagementOfficeForm/TelephoneNumberForm.vue"
import { useAuth } from "@/services/user/Auth0UserProvider"
import { useRoute, useRouter } from 'vue-router'
import { Ref, ref, onBeforeUnmount } from 'vue'
import {scrollToErrorComponent} from "@/services/validators"
import i18n from '@/lang/i18n'


export default /*@__PURE__*/_defineComponent({
  __name: 'SubManagementOfficeForm',
  props: {
    showFlash: { type: Function },
    switchContentLoading: { type: Function }
  },
  setup(__props: any) {

const props = __props

const { loginWithRedirect } = useAuth()
const router = useRouter()
const route = useRoute()
const title: Ref<string> = ref('')
const showableUpdateButton: Ref<boolean> = ref(false)
const errors: any = ref({})
const subManagementOffice = ref({} as createOrUpdateSubManagementOffice)
const isUpdating: Ref<boolean> = ref(false)
const subManagementOfficeId: Ref<number | null> = ref(null)
const windowInnerWidth: Ref<number> = ref(window.innerWidth);

(async () => {
  props.switchContentLoading(true)
  if (route.params.id) subManagementOfficeId.value = Number(route.params.id)
  const titlePrefix = i18n.global.t('pages.subManagementOffice.title.listTitle')
  const titleSuffix = subManagementOfficeId.value ? i18n.global.t('pages.subManagementOffice.title.editTitle') : i18n.global.t('pages.subManagementOffice.title.createTitle')
  title.value = `${titlePrefix}/${titleSuffix}`
  document.title = title.value

  AuthorityCacheApi.getWithParse().then((authorityList) => {
    if (subManagementOfficeId.value) {
      showableUpdateButton.value = !!authorityList["octlink.submanagement_office.update"]
    } else {
      showableUpdateButton.value = !!authorityList["octlink.submanagement_office.create"]
    }
    if (!authorityList["octlink.submanagement_office.read"]) {
      router.push('/')
    }
  })

  if (subManagementOfficeId.value) {
    const response = await Api().getSubManagementOffice(subManagementOfficeId.value)
      .catch((error) => {
        if (error.request.status == 403) {
          props.showFlash(i18n.global.t('pages.common.messages.notEditAuthority'), "error", true)
          router.push('/sub-management-offices/')
        }
        return errorHandle(error.request)
      })
    if(response) {
      subManagementOffice.value = response
      if (!subManagementOffice.value.zipcode) addInitialValue()
      subManagementOffice.value.ip_keeps_effective = 0
    }
  }
  props.switchContentLoading(false)
})()

function addInitialValue() {
  subManagementOffice.value.zip1 = ""
  subManagementOffice.value.zip2 = ""
}

function submit () {
  isUpdating.value = true
  const requestParams = makeRequestParams()
  Api().createOrUpdateSubManagementOffice(subManagementOfficeId.value ?? null, requestParams).then(() => {
    success()
  }).catch((error) => {
    errorHandle(error.response)
  })
}

function makeRequestParams (): createOrUpdateSubManagementOffice {
  let zipcode = ""
  if (subManagementOffice.value?.zip1 && subManagementOffice.value?.zip2) {
    zipcode = `${subManagementOffice.value.zip1}-${subManagementOffice.value.zip2}`
  }

  subManagementOffice.value.zipcode = zipcode
  subManagementOffice.value.payment_site = subManagementOffice.value.payment_site ?? 0
  subManagementOffice.value.payment_day = subManagementOffice.value.payment_day ?? 0
  subManagementOffice.value.has_file = subManagementOffice.value?.img ? 1 : 0
  subManagementOffice.value.password_expire_days = subManagementOffice.value?.password_expire_days ?? 0
  subManagementOffice.value.password_expire_days_checkbox = subManagementOffice.value?.password_expire_days ? 1 : 0
  subManagementOffice.value.login_error_limit_times = subManagementOffice.value.login_error_limit_times ?? 0
  subManagementOffice.value.login_error_limit_times_checkbox = subManagementOffice.value?.login_error_limit_times ? 1 : 0
  subManagementOffice.value.ip_keeps_effective = subManagementOffice.value?.ip_address?.length ? 1 : 0
  subManagementOffice.value.ip_address = subManagementOffice.value.ip_address ?? []

  return subManagementOffice.value
}


function success () {
  isUpdating.value = false
  router.push('/sub-management-offices')
  props.showFlash(i18n.global.t('pages.common.messages.success'), "success", true)
}

function errorHandle (res: any) {
  switch (res.status) {
    case 401:
      loginWithRedirect({ appState: { targetUrl: location.pathname } })
      break
    case 403:
      props.showFlash(i18n.global.t('pages.common.messages.notEditAuthority'), "error", true)
      showableUpdateButton.value = false
      break
    case 422:
      errors.value = res.data.errors
      scrollToErrorComponent()
  }
  return isUpdating.value = false
}

function handleResize () {
  windowInnerWidth.value = window.innerWidth
}

window.addEventListener('resize', handleResize)

onBeforeUnmount(() => {
  props.switchContentLoading(false)
})

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h4", _hoisted_2, _toDisplayString(title.value), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(TextField, {
          modelValue: subManagementOffice.value.dks_no_initial,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((subManagementOffice.value.dks_no_initial) = $event)),
          title: _unref(i18n).global.t('pages.subManagementOffice.dksNoInitial'),
          error: errors.value.dks_no_initial,
          windowInnerWidth: windowInnerWidth.value
        }, null, 8, ["modelValue", "title", "error", "windowInnerWidth"]),
        _createVNode(TextField, {
          modelValue: subManagementOffice.value.company_name,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((subManagementOffice.value.company_name) = $event)),
          title: _unref(i18n).global.t('pages.subManagementOffice.companyName'),
          error: errors.value.company_name,
          windowInnerWidth: windowInnerWidth.value,
          required: true
        }, null, 8, ["modelValue", "title", "error", "windowInnerWidth"]),
        _createVNode(TextField, {
          modelValue: subManagementOffice.value.company_name_japan,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((subManagementOffice.value.company_name_japan) = $event)),
          title: _unref(i18n).global.t('pages.subManagementOffice.form.companyNameJapan'),
          error: errors.value.company_name_japan,
          windowInnerWidth: windowInnerWidth.value,
          required: true
        }, null, 8, ["modelValue", "title", "error", "windowInnerWidth"]),
        _createVNode(TextField, {
          modelValue: subManagementOffice.value.contact_name,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((subManagementOffice.value.contact_name) = $event)),
          title: _unref(i18n).global.t('pages.subManagementOffice.contactName'),
          error: errors.value.contact_name,
          windowInnerWidth: windowInnerWidth.value
        }, null, 8, ["modelValue", "title", "error", "windowInnerWidth"]),
        _createVNode(AddressForm, {
          modelValue: subManagementOffice.value,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((subManagementOffice).value = $event)),
          errors: errors.value,
          windowInnerWidth: windowInnerWidth.value
        }, null, 8, ["modelValue", "errors", "windowInnerWidth"]),
        _createVNode(TelephoneNumberForm, {
          modelValue: subManagementOffice.value,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((subManagementOffice).value = $event)),
          errors: errors.value,
          windowInnerWidth: windowInnerWidth.value
        }, null, 8, ["modelValue", "errors", "windowInnerWidth"]),
        _createVNode(TextField, {
          modelValue: subManagementOffice.value.email,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((subManagementOffice.value.email) = $event)),
          title: _unref(i18n).global.t('pages.subManagementOffice.form.email'),
          error: errors.value.email,
          windowInnerWidth: windowInnerWidth.value
        }, null, 8, ["modelValue", "title", "error", "windowInnerWidth"]),
        _createVNode(TextArea, {
          modelValue: subManagementOffice.value.comment,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((subManagementOffice.value.comment) = $event)),
          title: _unref(i18n).global.t('pages.subManagementOffice.comment'),
          error: errors.value.comment,
          windowInnerWidth: windowInnerWidth.value
        }, null, 8, ["modelValue", "title", "error", "windowInnerWidth"])
      ]),
      (showableUpdateButton.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_router_link, { to: { name: 'SubManagementOffices' } }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, { class: "ma-2 reset-btn" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(i18n).global.t('common.cancelBtn')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_btn, {
              class: "ma-2 exec-btn",
              onClick: submit,
              loading: isUpdating.value
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.common.button.conservation')), 1)
              ]),
              _: 1
            }, 8, ["loading"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})